module.exports = __webpack_public_path__ + "static/media/hair-stylists-qualified.b60a45ba.jpg";